import Swal, { SweetAlertOptions, SweetAlertPosition } from "sweetalert2";
import { getIcon } from "@/utils/notification-helpers";

interface Toast {
  message: string;
  duration?: number;
  type?: string;
}

export const showToast = (settings: Toast) => {
  Swal.fire({
    toast: true,
    text: settings.message,
    position: "top",
    timer: settings.duration ?? 3000,
    showConfirmButton: false,
    background: "#f8f9fa",
    iconHtml: getIcon(settings.type ?? "is-info")
  });
};

interface Dialog {
  message: string;
  cancelText: string;
  confirmText: string;
  denyText?: string;
  type?: string;
  onConfirm: Function;
  onDismiss?: Function;
  onDeny?: Function;
  customClass?: {
    cancelButton?: string;
    confirmButton?: string;
    denyButton?: string;
  };
}

export const showDialog = (settings: Dialog) => {
  const config: SweetAlertOptions = {
    text: settings.message,
    showCancelButton: true,
    showDenyButton: !!settings.denyText,
    confirmButtonText: settings.confirmText,
    cancelButtonText: settings.cancelText,
    iconHtml: getIcon(settings.type ?? "is-question"),
    buttonsStyling: false,
    customClass: {
      cancelButton: settings?.customClass?.cancelButton ?? "button",
      confirmButton:
        settings?.customClass?.confirmButton ?? "button is-primary",
      denyButton: settings?.customClass?.denyButton ?? "button is-light"
    },
    reverseButtons: true
  };
  if (settings.denyText) {
    config["denyButtonText"] = settings.denyText;
  }
  Swal.fire(config).then(result => {
    if (result.isConfirmed) {
      settings.onConfirm();
    }
    if (result.isDismissed && settings.onDismiss) {
      settings.onDismiss();
    }
    if (result.isDenied && settings.onDeny) {
      settings.onDeny();
    }
  });
};

interface Snackbar {
  message?: string;
  html?: string;
  confirmText?: string;
  type?: string;
  onConfirm?: Function;
  position?: SweetAlertPosition;
}

export const showSnackbar = (settings: Snackbar) => {
  const options: SweetAlertOptions = {
    showCancelButton: false,
    showConfirmButton: false,
    iconHtml: getIcon(settings.type ?? "is-info"),
    buttonsStyling: false,
    customClass: {
      confirmButton: "button is-primary"
    }
  };
  if (settings.message) {
    options.text = settings.message;
  } else if (settings.html) {
    options.html = settings.html;
  }
  if (settings.confirmText) {
    options.confirmButtonText = settings.confirmText;
    options.showConfirmButton = true;
  }
  if (settings.position) {
    options.position = settings.position;
  }
  Swal.fire(options).then(result => {
    if (result.isConfirmed && settings.onConfirm) {
      settings.onConfirm();
    }
  });
};
